/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */

import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
declare var $: any;

@Component({
  selector: 'zsd-numberfield',
  templateUrl: '../../view/customfields/numberfield.component.html',
  styleUrls: ['../../view/customfields/customfields.component.scss']
})
export class NumberFieldComponent implements OnInit {

  @Input('parentForm') public parentForm: FormGroup;
  @Input() displayName = '';
  @Input() fieldType;
  @Input() description;
  @Input() dscEnable;
  @Input() required;
  @Input() fieldId;
  @Input() clientEditable;
  @Input() defaultValue;
  @Input() valueType;
  @Input('fromQuickCall') public fromQuickCall: boolean;


  numberFieldFocus = false;

  customFieldValue;

  numberFieldForm: FormGroup;
  numberField = false;
  customValidators = [];
  constructor(public formBuilder: FormBuilder) { }


  ngOnInit() {
    // Setup for description jquery
    if (this.dscEnable === 1) {
      $(document).ready(function () {
        $('[data-toggle=' + this.fieldId + ']').popover();
      }.bind(this));
    }
    // Setup for Reactive Form

    this.numberFieldForm = this.formBuilder.group({
      data: this.formBuilder.control({value: null, disabled: (this.clientEditable ? false : true) }),
    });

    // this.customFieldValue = 1;
    if (this.defaultValue) {
      this.customFieldValue = this.getFormattedNumberField(this.defaultValue);
      this.numberFieldForm.get('data').setValue(this.customFieldValue);
    }
    if (this.required === 1) {
      this.customValidators.push(Validators.required);
    }
    if (this.fieldType === 1) {
      this.numberField = true;
    }
    if (this.fieldType === 0 && this.valueType === 0) {
      this.customValidators.push(Validators.min(1));
      this.customValidators.push(Validators.max(5));
    }
    if (this.fieldType === 0 && this.valueType === 1) {
      this.customValidators.push(Validators.min(1));
      this.customValidators.push(Validators.max(10));
    }
    this.numberFieldForm.get('data').setValidators(this.customValidators);
    this.numberFieldForm.updateValueAndValidity();
    this.parentForm.addControl(this.fieldId + '', this.numberFieldForm);
    this.parentForm.setControl(this.fieldId + '', this.numberFieldForm);
  }

  // number validator
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  numberValueFormatter() {
    this.customFieldValue = this.customFieldValue.replace(/[^\d\.\-eE+]/g, '');
    this.customFieldValue = (this.customFieldValue && this.customFieldValue !== '') ? parseFloat(this.customFieldValue) : '';
    if (isNaN(this.customFieldValue)) {
      this.customFieldValue = '';
    }
    this.parentForm.setControl(this.fieldId + '', this.numberFieldForm);
    this.numberFieldForm.get('data').setValue(this.customFieldValue);
    this.numberFieldForm.updateValueAndValidity();
  }

  getFormattedNumberField(numberFieldValue) {
    numberFieldValue = numberFieldValue.replace(/[^\d\.\-eE+]/g, '');
    numberFieldValue = numberFieldValue ? parseFloat(numberFieldValue) : '';
    if (isNaN(numberFieldValue)) {
      numberFieldValue = '';
    }
    return numberFieldValue;
  }

  numberValueEmpty() {
    return this.numberFieldForm.get('data').value === '';
  }

  numberValueUpdate() {
    this.numberFieldForm.get('data').setValue(this.customFieldValue);
    this.numberFieldForm.updateValueAndValidity();
    this.parentForm.setControl(this.fieldId + '', this.numberFieldForm);
  }
}
